import { useState, useEffect } from 'react';

import UserApi from '../api/UserApi';

const useUserName = () => {
    const [userName, setUserName] = useState<string | null>('');

    useEffect(() => {
        UserApi.getUserDisplayName()
            .then(setUserName)
            .catch(() => {
                setUserName(null);
            });
    }, []);

    return userName;
};

export default useUserName;
